import React from 'react';
import { cn } from '@/utils/cn';
import { DonutLegendChart, DonutLegendChartItem } from '@/components/ui/DonutLegendChart';
import { ProjectDetail } from '../types/projectDetail.types';

interface ProjectOverviewSidebarProps {
  project: ProjectDetail;
}

export function ProjectOverviewSidebar({ project }: ProjectOverviewSidebarProps) {
  const progressData: DonutLegendChartItem[] = [
    { name: 'Đã hoàn thành', value: 45, color: '#10b981' },
    { name: 'Đang thực hiện', value: 30, color: '#0ea5e9' },
    { name: 'Chưa bắt đầu', value: 25, color: '#f97316' },
  ];

  return (
    <div className="space-y-6">
      {/* Tiến độ tổng thể - Standard Chart Component */}
      <DonutLegendChart 
        title="Tiến độ tổng thể"
        centerValue="45%"
        centerLabel="Hoàn thành"
        data={progressData}
        total={100}
        showLegendPercent={true}
        className="border-slate-100 "
      />

      {/* Nhân sự tham gia */}
      <section className="rounded-md bg-white p-4  border border-slate-100 space-y-4">
        <h3 className="text-sm font-normal text-slate-900 tracking-wider border-b border-slate-50 pb-2">Nhân sự tham gia</h3>
        <div className="space-y-3">
          {project.members.map((person, index) => (
            <div key={index} className="flex items-center gap-3 group cursor-pointer">
              <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center text-slate-400 font-normal text-xs border border-slate-50 group-hover:border-emerald-200 transition-all">
                {person.avatarUrl ? (
                  <img src={person.avatarUrl} alt={person.fullName} className="w-full h-full rounded-full object-cover" />
                ) : (
                  person.fullName.charAt(0)
                )}
              </div>
              <div className="flex flex-col leading-tight">
                <span className="text-xs lg:text-sm font-normal text-slate-700 group-hover:text-emerald-600 transition-colors">{person.fullName}</span>
                <span className="text-xs font-normal text-slate-400">{person.role}</span>
              </div>
            </div>
          ))}
          <button className="w-full py-2 rounded-md border border-dashed border-slate-200 text-xs font-normal text-slate-400 hover:text-emerald-600 hover:border-emerald-200 hover:bg-emerald-50/30 transition-all mt-2">
            + Thêm nhân sự
          </button>
        </div>
      </section>

      {/* Ghi chú & Lưu ý */}
      <section className="rounded-md bg-white p-4  border border-slate-100 space-y-3">
        <div className="flex items-center gap-2 text-amber-600">
          <i className="ri-sticky-note-line" />
          <h3 className="text-sm font-normal tracking-wider">Lưu ý quan trọng</h3>
        </div>
        <div className="p-3 rounded-md bg-amber-50/50 border border-amber-100">
           <p className="text-xs lg:text-sm font-normal text-amber-800 leading-relaxed italic">
             "Dự án đang trong giai đoạn bàn giao mặt bằng tầng 2. Cần chú trọng an toàn lao động tại khu vực hố thang máy."
           </p>
        </div>
        <div className="flex items-center justify-between pt-2">
          <span className="text-xs font-normal text-slate-400">Cập nhật lúc: 10:30 - 03/05</span>
          <button className="text-xs font-normal text-emerald-600 hover:underline">Chỉnh sửa</button>
        </div>
      </section>
    </div>
  );
}
